import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Input from '../form/input';
import { showAction as lockUi, hideAction as unlockUi } from '../../../_flux/actions/ui_lock_actions';
import { addLoadingAction, removeLoadingAction, updateCodeAction } from '../../actions/voucher_code_light_box_actions';
import { isReCaptchaActionAllowed } from '../../../../lib/utilities';

const setValueGlobal = (key, value, ttl = 30000) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };

  TYROOLA.globals[key] = JSON.stringify(item);
};

const getValueGlobal = (key) => {
  const itemStr = TYROOLA.globals[key];

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    TYROOLA.globals[key] = null;
    return null;
  }
  return item.value;
};

const saveReCaptchaToken = (data, token) => {
  const recaptchaTokens = getValueGlobal('recaptchaTokens');
  setValueGlobal(
    'recaptchaTokens',
    {
      [`PDP_SIDEBAR_VOUCHER_INPUT_${TYROOLA.globals.store}`]: data
        ? token
        : recaptchaTokens
        ? recaptchaTokens[`PDP_SIDEBAR_VOUCHER_INPUT_${TYROOLA.globals.store}`]
        : null,
      [`CART_SIDEBAR_VOUCHER_${TYROOLA.globals.store}`]: !data
        ? token
        : recaptchaTokens
        ? recaptchaTokens[`CART_SIDEBAR_VOUCHER_${TYROOLA.globals.store}`]
        : null,
    },
    120000,
  );
};

const getReCaptchaToken = (data) => {
  const recaptchaTokens = getValueGlobal('recaptchaTokens');

  if (!recaptchaTokens) {
    return null;
  }

  return data
    ? recaptchaTokens[`PDP_SIDEBAR_VOUCHER_INPUT_${TYROOLA.globals.store}`]
    : recaptchaTokens[`CART_SIDEBAR_VOUCHER_${TYROOLA.globals.store}`];
};
function VoucherCodeLightBoxContent(props) {
  const { data, onRedeem, onClose, loading } = props;
  const isReCaptchaAllowed = isReCaptchaActionAllowed('_SIDEBAR_VOUCHER_');

  const onClickRedeemBtn = (data, code, tokenString) => {
    let token = tokenString;

    if (data) {
      data.newVoucher.voucherValue = code;

      data.recaptchaToken = undefined;
      if (token) {
        data.recaptchaToken = token;
      }
    }

    if (token) {
      saveReCaptchaToken(data, token);
    } else {
      token = getReCaptchaToken(data);
      if (data) {
        data.recaptchaToken = token || undefined;
      }
    }

    onRedeem(data || code, null, token);
  };

  return (
    <div className="cross-sell-remove-light-box__content cross-sell-remove-light-box-content cross-sell-remove-light-box-content__actions">
      <div className="voucher-form__input-container align-items-center" style={{ width: '100%' }}>
        <Input
          className={`voucher-form__voucher-input`}
          type="text"
          name="voucherValue"
          placeholder="Enter it here: "
          value={props.code}
          onChange={(e) => updateCodeAction(e.target.value)}
          disabled={loading}
        />

        <Translation
          tagName="button"
          className={`voucher-form__submit g-recaptcha`}
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();

            lockUi();
            addLoadingAction();
            !isReCaptchaAllowed && onClickRedeemBtn(data, props.code, null);
            try {
              isReCaptchaAllowed &&
                grecaptcha.enterprise.ready(async () => {
                  try {
                    const token = await grecaptcha.enterprise.execute(TYROOLA.globals.google.recaptcha.keyId, {
                      action: data
                        ? `PDP_SIDEBAR_VOUCHER_INPUT_${TYROOLA.globals.store}`
                        : `CART_SIDEBAR_VOUCHER_${TYROOLA.globals.store}`,
                    });
                    onClickRedeemBtn(data, props.code, token);
                  } catch (err) {
                    unlockUi();
                    removeLoadingAction();
                  }
                });
            } catch (err) {
              unlockUi();
              removeLoadingAction();
            }
          }}
          translationKey="cart-voucher-redeem"
        />
      </div>

      {props.error && props.error.invalid && (
        <p
          className="floating-label-element__hint--invalid"
          dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
        />
      )}

      {props.error && props.error.valid && (
        <p
          className="floating-label-element__hint--valid"
          dangerouslySetInnerHTML={toDangerousReactHtml(props.error.validMessage)}
        />
      )}
    </div>
  );
}

VoucherCodeLightBoxContent.propTypes = {
  error: PropTypes.object,
  onRedeem: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { VoucherCodeLightBoxContent };
